<div class="filter full-span">
  <span class="input-group-btn">
    <button class="btn toggle-btn" [class.off]="!flask.show" (click)="toggleShowFlask()"></button>
  </span>
  <span class="filter-body" [class.equipment-filter-from-preset]="flask.fromProgressPreset || flask.fromClassPreset">
    <app-select style="width: 110px" [disabled]="!flask.show" [(ngModel)]="flask.flaskClass" (selectedValueChange)="flaskClassChanged();">
      @for (flaskClass of flaskClasses; track flaskClass) {
        <app-option [value]="flaskClass.name" [text]="classToNameMap[flaskClass.name]" [imgUrl]="imgPrefix + flaskClass.image!"></app-option>
      }
    </app-select>
    <span class="sep"></span>
    <app-autocomplete
      [options]="flaskBaseTypes"
      [disabled]="!flask.show"
      [showOptions]="true"
      [selectedValues]="flask.flaskBaseTypes"
      (selectedValuesChange)="flaskBaseTypesChanged($event);"></app-autocomplete>
    <span class="sep"></span>
    <app-select-rarity [greaterThanOrEqualTo]="true" [includeUnique]="false" [includeRare]="false" [disabled]="!flask.show" [(ngModel)]="flask.rarity" (selectedValueChange)="minRarityChanged($event);"></app-select-rarity>
    <span class="sep"></span>
    <input type="number" placeholder="≥ Qual" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" style="min-width: 70px;"
      [disabled]="!flask.show"
      [(ngModel)]="flask.quality" (change)="qualityChanged()">
    <span class="sep"></span>
    <input type="number" placeholder="≥ iLvl" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" style="min-width: 55px;"
      [disabled]="!flask.show"
      [(ngModel)]="flask.itemLevel" (change)="updateFilter()">
    <span class="sep"></span>
    <span class="input-group-btn">
      <button class="btn toggle-button customize-btn" [class.no-conditions]="hasHighlightConfig === 0" [class.active]="highlightConfigOpen" [class.disabled]="!flask.show"
        (click)="toggleHighlightConfigOpen()">
        <span class="icon icon-equalizer"></span>
        <span class="label">{{ hasHighlightConfig }}</span>
      </button>
    </span>

    <span class="sep"></span>
    <span class="input-group-btn">
      <button class="btn remove-btn" (click)="removeFlaskType()"></button>
    </span>
  </span>
</div>

@if (navigationEnabled || highlightConfigOpen) {
  <div [class.collapsed]="!highlightConfigOpen">
    <app-my-flask-charm-highlights
      [flask]="flask"
      [equipmentType]="'flask'"
      [equipmentIndex]="index"
      (updateFilterEmitter)="hasHighlightConfig = getNumberOfHighlightConfig(); updateFilter()"></app-my-flask-charm-highlights>
    <div class="clear"></div>
  </div>
}
